import './loading-view.css';
import React, { FC } from 'react';

import arenLogo from '../assets/aren-login-logo.webp';

export const LoadingView: FC = () => (
	<div data-testid={'loading-view'} className="splash">
		<img className="splash-logo" src={arenLogo} alt={'Aren'} />
		<div className="loader">
			<div className="bar"></div>
		</div>
	</div>
);
